import { useEffect, useRef, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { savePortalSession } from '../services/portalAuth';
import { portalApi } from '../services/portalApi';
import './PortalVerifyPage.css';

export default function PortalVerifyPage() {
  const { token }    = useParams();
  const navigate     = useNavigate();
  const [status, setStatus] = useState('verifying'); // verifying | error
  // Guard against React 18 StrictMode's intentional double-mount in dev,
  // which would consume the single-use token on the first call and return 401 on the second.
  const called = useRef(false);

  useEffect(() => {
    if (!token || called.current) return;
    called.current = true;

    portalApi.verifyMagicLink(token)
      .then(data => {
        if (!data) return; // 401 handler already redirected
        savePortalSession({ email: data.email, name: data.name, exp: data.exp });
        navigate('/portal', { replace: true });
      })
      .catch(() => setStatus('error'));
  }, [token, navigate]);

  if (status === 'verifying') {
    return (
      <div className="portal-verify-page">
        <div className="pvp-card">
          <div className="pvp-spinner" aria-hidden="true" />
          <p className="pvp-message">Signing you in…</p>
        </div>
      </div>
    );
  }

  return (
    <div className="portal-verify-page">
      <div className="pvp-card pvp-error">
        <div className="pvp-icon" aria-hidden="true">⚠</div>
        <h2>Link expired or already used</h2>
        <p>This login link is no longer valid. Please request a new one.</p>
        <a href="/portal/login" className="pvp-btn">Request a new link</a>
      </div>
    </div>
  );
}
